var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17.194,
    viewBox: "0 0 15 17.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(204.365 -634.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-192.453,652.112h-8.824a3.091,3.091,0,0,1-3.088-3.088V638.006a3.091,3.091,0,0,1,3.088-3.088h8.824a3.091,3.091,0,0,1,3.088,3.088v11.019A3.091,3.091,0,0,1-192.453,652.112Zm-8.824-15.906a1.8,1.8,0,0,0-1.8,1.8v11.019a1.8,1.8,0,0,0,1.8,1.8h8.824a1.8,1.8,0,0,0,1.8-1.8V638.006a1.8,1.8,0,0,0-1.8-1.8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M-185.88,656.1H-195.2a.644.644,0,0,1-.644-.644.644.644,0,0,1,.644-.644h9.324a.644.644,0,0,1,.644.644A.644.644,0,0,1-185.88,656.1Z",
    transform: "translate(-6.323 -14.769)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M-185.88,667.08H-195.2a.644.644,0,0,1-.644-.644.644.644,0,0,1,.644-.644h9.324a.644.644,0,0,1,.644.644A.644.644,0,0,1-185.88,667.08Z",
    transform: "translate(-6.323 -22.921)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M-185.88,678.061H-195.2a.644.644,0,0,1-.644-.644.644.644,0,0,1,.644-.644h9.324a.644.644,0,0,1,.644.644A.644.644,0,0,1-185.88,678.061Z",
    transform: "translate(-6.323 -31.073)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.4136d824.svg";
export { ForwardRef as ReactComponent };